import React from "react";
import { LeftOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import Timer from "../assets/images/stopwatch.png";
import { Select } from "antd";

const TradeHistory = () => {
  const filters = ["filter1", "filter2", "filter3"];

  return (
    <div className="w-full p-4 lg:p-8">
      <div className="flex items-center gap-2 mb-6 cursor-pointer">
        <NavLink
          to="/"
          className="flex items-center gap-2 text-primary hover:text-[#0f5a94]"
        >
          <LeftOutlined className="text-lg" />
          <span className="text-base font-medium">Back</span>
        </NavLink>
      </div>

      <div className="flex items-center gap-3 mb-6">
        <img src={Timer} alt="timer" className="w-6 h-6" />
        <h3 className="text-xl lg:text-2xl font-semibold text-[#454545]">
          Trade Book(12)
        </h3>
      </div>

      <div className="flex flex-col sm:flex-row gap-4 mb-8">
        <div className="w-full sm:w-auto">
          <Select
            placeholder="Segment"
            className="w-full sm:min-w-[200px]"
            options={filters?.map((filter) => ({
              value: filter,
            }))}
          />
        </div>
        <div className="w-full sm:w-auto">
          <Select
            placeholder="Date Range"
            className="w-full sm:min-w-[200px]"
            options={filters?.map((filter) => ({
              value: filter,
            }))}
          />
        </div>
        <div className="w-full sm:w-auto">
          <button className="w-full sm:w-auto px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/80 transition-colors font-medium">
            Generate
          </button>
        </div>
      </div>

      {/**table */}

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-[#f5f7fa] border-b border-brand-border">
              <th className="text-left px-4 py-3 text-[#454545] font-semibold text-sm lg:text-base">
                Script
              </th>
              <th className="text-left px-4 py-3 text-[#454545] font-semibold text-sm lg:text-base">
                Qty.
              </th>
              <th className="text-left px-4 py-3 text-[#454545] font-semibold text-sm lg:text-base">
                Buy avg.
              </th>
              <th className="text-left px-4 py-3 text-[#454545] font-semibold text-sm lg:text-base">
                Sell avg.
              </th>
              <th className="text-left px-4 py-3 text-[#454545] font-semibold text-sm lg:text-base">
                Realized P&L
              </th>
              <th className="text-left px-4 py-3 text-[#454545] font-semibold text-sm lg:text-base">
                Un-Realized P&L
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-brand-border hover:bg-brand-gray transition-colors">
              <td className="px-4 py-3 text-[#454545] font-medium text-sm lg:text-base">
                DIVISLAB AUG
              </td>
              <td className="px-4 py-3 text-primary font-medium text-sm lg:text-base">
                4
              </td>
              <td className="px-4 py-3 text-[#454545] text-sm lg:text-base">
                1,234.00
              </td>
              <td className="px-4 py-3 text-[#454545] text-sm lg:text-base">
                1,234.90
              </td>
              <td className="px-4 py-3 text-[#EF4444] font-medium text-sm lg:text-base">
                -1511.22
              </td>
              <td className="px-4 py-3 text-[#10B981] font-medium text-sm lg:text-base">
                +440.00
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TradeHistory;
